import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setPremiumPackageChanged, resetPremiumPackage, reportDWH, setProductWorldList } from '../saleJetBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync, getCustomerAddresses } from '../saleBlockAsyncThunk';
import Config from '../../../../Config';
import PremiumPackages from '../Partials/PremiumPackages/premiumPackages'
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import lightIcon from '../Partials/PremiumPackages/images/icon-light.svg';
import Image from 'app/Components/Shared/Image/image';

const PremiumPackagesPage = (props) => {

  useEffect(() => {
    props.reportDWH({ actionType: 'Premium Select', status: 'Ongoing', messageText: 'Premium Select Page Displayed' });
    gtag4({
      event: `${props.saleType}Step5_PremiumPage`,
      step: '5',
      action:  'PremiumPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }, []);

  useEffect(() => {
    if (!props.isLoadingShoppingCart) {
      props.hideAppLoader();
    }
  }, [props.isLoadingShoppingCart]);


  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let title = '';
  let subTitle = '';
  let remark = '';

  if (props.orderType == 'replace') {
    title = (<> {props._authentication.loginData.userDetails.firstName}, תרצה לשדרג את חווית הצפייה <br /> עם חבילות פרימיום נוספות? </>);
    subTitle = (<> אל חשש, החבילות שהיו לך עד כה במנוי כבר מסומנות. <br /> במידה ובהמשך תרצה לעדכן, תוכל לעשות זאת בעזרת השלט באופן עצמאי. </>);
    remark = (<> שימו לב, מחירי ערוצי הפרימיום הם לפי המוצג  ולא כפי שהיה עד כה. </>);
  }
  else {
    title = (<> בא לך לשדרג את חויית הצפייה <br /> עם חבילות ערוצי הפרימיום? </>);
    subTitle = (<> <a href='#' onClick={()=>handlePageContinue('דלג')}>דלג</a> </>);
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
      {remark && <h3 className="sale-title-small-purple light-icon"><Image src={lightIcon} alt="light" className="icon" /> {remark} </h3>}
    </div>
  );

  const premiumPackagesByGroups = props.premiumPackages.reduce((groups, item) => {
    const categories = item.cmsData?.categories;
    categories?.map(function (category, i) {
      var categoryName = category.categoryName;
      if (!groups[categoryName]) {
        groups[categoryName] = [];
      }
      groups[categoryName].push(item);
    });
    return groups;
  }, {});

  let currentPageView = <PremiumPackages flowType={props.flowType} saleType={props.saleType} gtag4={gtag4} context={props.context} isLoadingShoppingCart={props.isLoadingShoppingCart} handleOnVasSelected={handleOnVasSelected} premiumPackages={props.premiumPackages} premiumPackagesByGroups={premiumPackagesByGroups} onPremiumPackageChange={onPremiumPackageChange} onSingleChoiceWorldSwitch={onSingleChoiceWorldSwitch} orderType={props.orderType} />;

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content width-664'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={() => currentPageFunction(btnText)} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function onSingleChoiceWorldSwitch(itemsToDeselect, itemToSelect, premiumPackage) {
    if (itemsToDeselect.length > 0) {
      props.setPremiumPackageChanged({ vasList: itemsToDeselect.map(item => item.name), isSelected: false, premiumPackage: premiumPackage });
      itemsToDeselect.forEach(item => {
        props.setProductWorldList({ world: premiumPackage.name, packageName: item.name, count: 0 });
      });
    }
    props.setPremiumPackageChanged({ vasList: [itemToSelect], isSelected: true, premiumPackage: premiumPackage });
    props.setProductWorldList({ world: premiumPackage.name, packageName: itemToSelect, count: 1 });
    props.showAppLoader();
    props.getSalePricesAsync();
    //props.resetPremiumPackage();
  }

  function onPremiumPackageChange(packageName, isSelected, premiumPackage) {
    props.setPremiumPackageChanged({ vasList: [packageName], isSelected: isSelected, premiumPackage: premiumPackage });
    if (premiumPackage.isPremiumPackagesWorld) {
      props.setProductWorldList({world: premiumPackage.name , packageName: packageName, count: isSelected ? 1 : 0 });
      props.showAppLoader();
    }
    props.getSalePricesAsync();
    //props.resetPremiumPackage();
  }

  function handleOnVasSelected(vasList, premiumPackage) {
    props.setPremiumPackageChanged({ vasList: vasList, isSelected: true, premiumPackage: premiumPackage });
    props.getSalePricesAsync();
    //props.resetPremiumPackage();
  }

  function handlePageContinue(buttonName) {
    props.reportDWH({ actionType: 'Premium Select', status: 'Ongoing', messageText: 'Premium Select Page Button Clicked' });
    const { routerInfo } = props.selectedPackage;
    const { nameRouterUpgrade} = routerInfo;

    switch (props.saleType) {
      case 'tv':
        if(props.addons?.length >= 1 ) {
          props.goToPage('addonsPage');
        }else {
          props.goToPage('addressPage');
          props.reportDWH({ actionType: 'Service Address', status: 'Ongoing', messageText: 'Service Address Page Displayed' });
        }
        break;
      case 'app':
        if (props.addons?.length >= 1){
          props.goToPage('addonsPage');
        }else if (props.flowType == 'existsCustomer') {
          props.getCustomerAddresses();
        }
        else {
          props.goToPage('personalInfoPage');
        }
        break;
      case 'triple':
        if(props.addons?.length > 0) {
          props.goToPage('addonsPage');
        } else {
          props.getTechnicianTimesAsync();
        }
        break;
    }
    gtag4({
      event: `${props.saleType}_Step5_PremiumPackageSkipButton`,
      step: '5',
      button: buttonName,
      action:  'PremiumPackageSkipButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    orderType: state.saleJetBlock.orderType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    premiumPackages: state.saleJetBlock.saleCatalog?.premiumPackages,
    selectedPremiumPackages: state.saleJetBlock.premiumPackages,
    isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
    addons: state.saleJetBlock.saleCatalog?.addons,
    routers: state.saleJetBlock.saleCatalog?.routers,
    selectedPackage: state.saleJetBlock.selectedPackage,
    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setPremiumPackageChanged,
  resetPremiumPackage,
  getSalePricesAsync,
  getTechnicianTimesAsync,
  getCustomerAddresses,
  reportDWH,
  showAppLoader,
  hideAppLoader,
  setProductWorldList
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumPackagesPage);
